import { createFileRoute } from '@tanstack/react-router'

import { productsQuery } from '../../lib/queries'
import { Products } from '../../screens/Products'

export const Route = createFileRoute('/products/')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { q?: string; active?: string; status?: string; order?: string } => ({
    q: typeof search.q === 'string' && search.q ? search.q : undefined,
    active: typeof search.active === 'string' && search.active ? search.active : undefined,
    status: typeof search.status === 'string' && search.status ? search.status : undefined,
    order: typeof search.order === 'string' && search.order ? search.order : undefined,
  }),
  loaderDeps: ({ search }) => ({ q: search.q }),
  loader: ({ context, deps }) =>
    Promise.all([
      context.queryClient.ensureQueryData(productsQuery()),
      deps.q && deps.q.length >= 3
        ? context.queryClient.ensureQueryData(productsQuery({ search: deps.q }))
        : Promise.resolve([]),
    ]),
  component: Products,
})
